import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";

import {useVerifiedPermissions} from "@flexinet/auth-components";
import {rbacActions} from "../../config/rbac/actions.ts";


export const PaymentIntentsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListPaymentIntents) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetPaymentIntent) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/payment-intents'/>
                    )
                }

            >
            </Route>

        </Routes>
    );
};
